import config from '@/config';

export type Route = {
  id: string;
  name: string;
  path: string;
  notSearchRoute?: boolean;
  exclude?: boolean;
};
export const areWeInSearchPage = (currentRoute: string) => {
  const salePaths = search.sale.routes.filter((route) => !route.notSearchRoute).map((route) => route.path);
  const rentalPaths = search.rental.routes.filter((route) => !route.notSearchRoute).map((route) => route.path);
  const searchPagePaths = salePaths.concat(rentalPaths);
  return searchPagePaths.some((path) => currentRoute.includes(path));
};

export const home = {
  path: '/',
};

export const optimizely = {
  path: '/',
};

export const allOptimizelyComponents = {
  path: '/kaikki-komponentit',
};

export const rentingLandingPage = {
  path: '/vuokraamassa/asuntosijoittaja',
};

export const listing = {
  path: '/kohde',
};

export const responsibilityProgram = {
  path: '/vastuullisuus',
};

export const unsubscribe = {
  path: '/peruuta-hakuvahti',
};

export const currentNewsItem = {
  path: '/uutiset',
};

export const condominium = {
  path: '/uudiskohde',
};

export const homeInsurance = {
  path: '/kotivakuutus',
};

export const changeApartments = {
  path: '/asunnonvaihto',
};

export const agencies = {
  path: '/kiinteistonvalitys',
};

export const corporateAgency = {
  path: '/kiinteistonvalitys/yhtio/:id',
};
export const corporateAgencyBasePath = {
  path: '/kiinteistonvalitys/yhtio',
};

export const contactPage = {
  path: '/ota-yhteytta',
};

export const priceCalculator = {
  path: '/asunnon-hintalaskuri',
};

export const calculator = {
  path: '/laskuri',
};

export const temporaryLoginLinks = {
  path: '/login',
};

export const liekkiSellersService = {
  path: '/myyjan-palvelu',
};

export const salesAndMarketing = {
  path: '/asunnon-markkinointi',
};

export const sellNewApartments = {
  path: '/uudiskohteiden-myynti',
};

export const buyingRequestTask = {
  path: '/ostotoimeksianto',
};

export const howWeSell = {
  path: '/asunnon-myynti',
};

export const componentCatalog = {
  path: '/catalog',
};

export const sellingYourCottage = {
  path: '/loma-asunnon-myynti',
};

export const diasPage = {
  path: '/digitaalinen-asuntokauppa',
  alias: '/digitaalinenasuntokauppa',
};

export const stylingServices = {
  path: '/stailauspalvelut',
};

export const careers = {
  path: '/avoimet-tyopaikat',
};

export const evaluationSpecialist = {
  path: '/avoimet-tyopaikat/arviointiasiantuntija',
};

export const whyRealtor = {
  path: '/miksi-kiinteistonvalittaja',
};

export const staticPage = {
  paths: {
    eula: '/kayttoehdot',
    accessibility: '/saavutettavuusseloste',
    about: '/tietoa-palvelusta',
    personalDataPropertyManagement: '/henkilotietojen-kasittely-isannointi',
    personalData: '/henkilotietojen-kasittely',
    listing: '/kohdehakuluettelo',
    pricing: '/palveluhinnasto',
    media: '/medialle',
    calculatorTerms: '/asiakkuusehdot',
    cookies: '/evasteet',
  },
};

export const apartmentsForSale = {
  path: '/myytavat/asunnot',
};

export const error = {
  path: '/virhe',
};

// Ostamassa ja vuokraamassa
export const search = {
  sale: {
    meta: {
      name: 'Ostamassa',
      path: '/myytavat',
      id: config.testing.NAVIGATION.BUYING_LANDING_PAGE,
    },
    routes: [
      {
        id: config.testing.NAVIGATION.BUYING.APARTMENTS,
        name: 'Asunnot',
        path: '/myytavat/asunnot',
      },
      {
        id: config.testing.NAVIGATION.BUYING.NEW_HOUSING,
        name: 'Uudiskohteet',
        path: '/myytavat/uudiskohteet',
      },
      {
        id: config.testing.NAVIGATION.BUYING.VACATION_HOUSING,
        name: 'Loma-asunnot',
        path: '/myytavat/loma-asunnot',
      },
      {
        id: config.testing.NAVIGATION.BUYING.SITES,
        name: 'Tontit',
        path: '/myytavat/tontit',
      },
      {
        id: config.testing.NAVIGATION.BUYING.FARMS,
        name: 'Maa- ja metsätilat',
        path: '/myytavat/maa-ja-metsatilat',
      },
      {
        id: config.testing.NAVIGATION.BUYING.OFFICES,
        name: 'Toimitilat',
        path: '/myytavat/toimitilat',
      },
      {
        id: config.testing.NAVIGATION.BUYING.GARAGES,
        name: 'Autotallit ja varastot',
        path: '/myytavat/autotallit-ja-varastot',
      },
      {
        id: config.testing.NAVIGATION.BUYING.BUYING_REQUEST_TASK,
        name: 'Ostotoimeksianto',
        path: buyingRequestTask.path,
        notSearchRoute: true,
      },
      {
        id: config.testing.NAVIGATION.BUYING.HOME_INSURANCE,
        name: 'Kotivakuutus',
        path: homeInsurance.path,
        notSearchRoute: true,
      },
      {
        name: 'OP:sta kaikki asunnonvaihtoon',
        id: config.testing.NAVIGATION.BUYING.CHANGE_APARTMENT_PAGE,
        path: changeApartments.path,
        notSearchRoute: true,
      },
    ] satisfies Route[],
  },
  rental: {
    meta: {
      name: 'Vuokraamassa',
      path: '/vuokraamassa',
      id: config.testing.NAVIGATION.RENTING_LANDING_PAGE,
    },
    routes: [
      {
        id: config.testing.NAVIGATION.RENTING.APARTMENTS,
        name: 'Asunnot',
        path: '/vuokrattavat/asunnot',
      },
      {
        id: config.testing.NAVIGATION.RENTING.VACATION_HOUSING,
        name: 'Loma-asunnot',
        path: '/vuokrattavat/loma-asunnot',
      },
      {
        id: config.testing.NAVIGATION.RENTING.OFFICES,
        name: 'Autotallit ja varastot',
        path: '/vuokrattavat/autotallit-ja-varastot',
      },
      {
        id: config.testing.NAVIGATION.RENTING.GARAGES,
        name: 'Toimitilat',
        path: '/vuokrattavat/toimitilat',
      },
      {
        id: config.testing.NAVIGATION.RENTING.RENTING_SECTION_PAGE,
        name: 'Vuokraajalle',
        path: '/vuokraamassa/asuntosijoittaja',
        exclude: true,
        notSearchRoute: true,
      },
    ] satisfies Route[],
  },
};

// Myymässä
export const selling = {
  meta: {
    id: config.testing.NAVIGATION.SELLING_LANDING_PAGE,
    name: 'Myymässä',
    path: '/myymassa',
  },
  routes: [
    {
      name: 'Näin myymme asuntosi',
      id: config.testing.NAVIGATION.SELLING.HOW_WE_SELL,
      path: howWeSell.path,
    },
    {
      name: 'OP Koti - kiinteistönvälitys',
      id: config.testing.NAVIGATION.SELLING.AGENCIES,
      path: agencies.path,
    },
    {
      name: 'Hinta-arviolaskuri',
      id: config.testing.NAVIGATION.SELLING.ESTIMATE,
      path: '/asunnon-hintalaskuri',
    },
    {
      name: 'Myyjän palvelu',
      id: config.testing.NAVIGATION.SELLING.SELLER_SERVICE,
      path: liekkiSellersService.path,
    },
    {
      name: 'Digitaalinen asuntokauppa',
      id: config.testing.NAVIGATION.SELLING.DIAS,
      path: diasPage.path,
    },
    {
      name: 'Stailauspalvelut',
      id: config.testing.NAVIGATION.SELLING.STYLING_SERVICES,
      path: stylingServices.path,
    },
    {
      name: 'Asunnon markkinointi',
      id: config.testing.NAVIGATION.BUYING.SALES_AND_MARKETING,
      path: salesAndMarketing.path,
      notSearchRoute: true,
    },
    {
      name: 'Uudiskohteiden myynti',
      id: config.testing.NAVIGATION.BUYING.SELL_NEW_APARTMENTS,
      path: sellNewApartments.path,
      notSearchRoute: true,
    },
    {
      name: 'Loma-asunnon myynti',
      id: config.testing.NAVIGATION.BUYING.SELL_COTTAGE,
      path: sellingYourCottage.path,
      notSearchRoute: true,
    },
  ],
};

// SEO page (for robots)
export const SEO = {
  name: 'Kohdehakuluettelo',
  path: '/kohdehakuluettelo',
};
